import {
  DownloadOutlined,
  DownOutlined,
  ExportOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { useState } from 'react';
import styles from '../../products/components/BulkUploadDropdown.module.scss';

interface LocationBulkUploadDropdownProps {
  entityLabel: string;
  entityLabelPlural: string;
  onDownloadTemplate: () => void;
  onExport: () => void;
  onImport: () => void;
  isDownloadingTemplate?: boolean;
  isExporting?: boolean;
  isImporting?: boolean;
}

export function LocationBulkUploadDropdown({
  entityLabel,
  entityLabelPlural,
  onDownloadTemplate,
  onExport,
  onImport,
  isDownloadingTemplate = false,
  isExporting = false,
  isImporting = false,
}: LocationBulkUploadDropdownProps) {
  const [open, setOpen] = useState(false);
  const isBusy = isDownloadingTemplate || isExporting || isImporting;

  const closeAndRun = (action: () => void) => {
    setOpen(false);
    action();
  };

  const popup = (
    <div className={styles.panel}>
      <div className={styles.panelAccent} />

      <div className={styles.header}>
        <span className={styles.headerTitle}>Import / Export {entityLabel}</span>
        <span className={styles.headerSubtitle}>
          Manage {entityLabelPlural.toLowerCase()} in bulk via spreadsheet
        </span>
      </div>

      <div className={styles.menuGroup}>
        <button
          type="button"
          className={styles.menuItem}
          disabled={isDownloadingTemplate}
          onClick={() => closeAndRun(onDownloadTemplate)}
        >
          <span className={`${styles.menuIconWrap} ${styles.menuIconGold}`}>
            <DownloadOutlined />
          </span>
          <span className={styles.menuText}>
            <strong>Download sample template</strong>
            <small>Empty XLSX with required columns</small>
          </span>
        </button>

        <button
          type="button"
          className={styles.menuItem}
          disabled={isExporting}
          onClick={() => closeAndRun(onExport)}
        >
          <span className={`${styles.menuIconWrap} ${styles.menuIconGreen}`}>
            <ExportOutlined />
          </span>
          <span className={styles.menuText}>
            <strong>Export {entityLabelPlural.toLowerCase()}</strong>
            <small>Download all {entityLabelPlural.toLowerCase()} as spreadsheet</small>
          </span>
        </button>
      </div>

      <div className={styles.divider} />

      <button
        type="button"
        className={`${styles.menuItem} ${styles.menuItemPrimary}`}
        disabled={isImporting}
        onClick={() => closeAndRun(onImport)}
      >
        <span className={`${styles.menuIconWrap} ${styles.menuIconAccent}`}>
          <UploadOutlined />
        </span>
        <span className={styles.menuText}>
          <strong>Import XLSX</strong>
          <small>Upload filled template to add or update {entityLabelPlural.toLowerCase()}</small>
        </span>
      </button>
    </div>
  );

  return (
    <Dropdown
      open={open}
      onOpenChange={setOpen}
      trigger={['click']}
      placement="bottomRight"
      popupRender={() => popup}
    >
      <Button icon={<UploadOutlined />} loading={isBusy}>
        <span className={styles.trigger}>
          Bulk upload
          <DownOutlined className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`} />
        </span>
      </Button>
    </Dropdown>
  );
}
